import React from "react";

const Partners = (props) => {
  const partnerInfo = (info) => (
    <>
      {info.description && (
        <>
          {info.description}
          <br />
        </>
      )}

      {info.linkName && info.link && (
        <>
          {info.linkName}:&nbsp;
          <a href={info.link}>{info.link}</a>
          <br />
        </>
      )}
    </>
  );

  const partnerItem = (partner) => (
    <li>
      <h3>{partner.name}</h3>
      <p>{partner.info.map((i) => partnerInfo(i))}</p>
    </li>
  );

  return <ul>{props.partners.map((partner) => partnerItem(partner))}</ul>;
};

export default Partners;
